import { render, staticRenderFns } from "./OrderDetailQuantity.vue?vue&type=template&id=16fb9316"
import script from "./OrderDetailQuantity.vue?vue&type=script&lang=js"
export * from "./OrderDetailQuantity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports